import Vue from 'vue'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { $ } from '@/utils/helpers'

const HISTORY_STATE = 'OVERLAY_PAGE_MODAL_STATE'

export default Vue.extend({
  data() {
    return {
      isActiveOverlayPageModal: false,
      overlayPageModalProps: null,
      $_isClosing: false,
      $_isDisableScroll: false,
      $_isBackFromChildPage: false,
      $_isBackFromBeyondChildPage: false,
      $_oldHistoryState: ''
    }
  },
  watch: {
    isActiveOverlayPageModal(val) {
      if (val) {
        history.pushState(HISTORY_STATE, null, this.overlayPageModalProps.pushUrl)
        // ページにアクセスしたということなのでアクションタイムを更新
        this.$_updateActionTime()
      }
    }
  },
  created() {
    window.addEventListener('popstate', this.$_handlePopState, false)
    if (this.$_platformIsAndroid) {
      document.addEventListener('backbutton', this.$_handleBackButtonOverlayPageModal, false)
    }
  },
  destroyed() {
    this.closeOverlayPageModal()

    window.removeEventListener('popstate', this.$_handlePopState, false)
    if (this.$_platformIsAndroid) {
      document.removeEventListener('backbutton', this.$_handleBackButtonOverlayPageModal, false)
    }
    if (this.$_isDisableScroll) {
      enableBodyScroll($('html'))
      this.$_isDisableScroll = false
    }
  },
  methods: {
    /**
     * 履歴の変更を検知してモーダルを閉じる
     */
    $_handlePopState(event: PopStateEvent) {
      // 子ページから戻ろうとしている
      this.$_isBackFromChildPage =
        (event.state && event.state.key) ||
        ((!event.state && (this.$_oldHistoryState && this.$_oldHistoryState['key'])) ||
          !this.$_oldHistoryState)
      // 子ページの先から戻ろうとしている
      this.$_isBackFromBeyondChildPage = event.state === HISTORY_STATE
      if (this.$_isBackFromChildPage || this.$_isBackFromBeyondChildPage) {
        this.closeOverlayPageModal()
      }
      this.$_oldHistoryState = event.state
    },

    async $_showOverlayProfileModal(props: any) {
      // ブロックなどを即時反映するために entry と key を一時的に確保
      const moduleName = this.$store.getters.fromStoreModuleName
      if (moduleName) {
        if (moduleName === 'TopUser') {
          this.$store.commit(
            'TopUser/setTempGridEntries',
            this.$store.getters['TopUser/gridEntries']
          )
        }
        this.$store.commit(`${moduleName}/clearTempEntries`)
        this.$store.commit(
          `${moduleName}/setTempEntries`,
          this.$store.getters[`${moduleName}/entries`]
        )
        this.$store.commit(`${moduleName}/setCurrentEntryKey`, props.key)
        if (props.keys) {
          this.$store.commit(`${moduleName}/setCurrentEntryKeys`, props.keys)
        }
      }

      // fromName を update
      this.$store.commit('setFromName', this.$route.name)

      props.scrollMonitorSelector = '.OverlayPageModal .modal-content'
      this.overlayPageModalProps = props

      if ($('body').style.overflow !== 'overflow') {
        // すでにロック中ならロックしない
        disableBodyScroll($('html'))
        this.$_isDisableScroll = true
      }

      // スクロール値をリセット
      await this.$nextTick()
      $(props.scrollMonitorSelector).scrollTop = 0
      this.isActiveOverlayPageModal = true
    },

    async closeOverlayPageModal() {
      if (!this.isActiveOverlayPageModal || this.$_isClosing) return
      this.$_isClosing = true

      // OvelryPageModal 内に app-navbar を含む場合 destroy されることで class が html タグから解除される

      if (this.$_isDisableScroll) {
        this.$_isDisableScroll = false
        enableBodyScroll($('html'))
      }
      this.isActiveOverlayPageModal = false
      this.$_isClosing = false
    },

    $_handleBackButtonOverlayPageModal() {
      if (this.isActiveOverlayPageModal) {
        this.closeOverlayPageModal()
      } else {
        this.$router.back()
      }
    }
  }
})
